import './App.css';
import React from 'react'
import Header from './Component/Header'
import Feature from './Component/features'
import AboutC from './Component/AboutComponent'
import Presentation from './Component/presentration' 
import Service from './Component/Services'
import Contact from './Component/Contact'


function App() {
  return (
    <div>
    <Header/>,
    <Feature/>,
    <AboutC/>,
    <Presentation/>,
    <Service/>,
    <Contact/>
    </div>
  );
}

export default App;
